import "./AccountLabelAdditionalContent.scss"

import { FooterVariant, Loader, SvgIcon } from "@skylead/component-library"
import React, { useState } from "react"
import { useSelector } from "react-redux"

import * as actions from "../../../redux/actions"
import { store } from "../../../redux/store"
// eslint-disable-next-line import/no-cycle
import accountUtils from "../../../utils/account-utils"
import { useGlobalTranslation } from "../../../utils/hook"
import InputGroup from "../../organisms/InputGroup"
import LinkedinSubscription from "../../organisms/LinkedinSubscription"
import LangText from "../LangText"
import { ModalVariant } from "../Modal"

const AccountLabelAdditionalContent = ({ person, statusName, accountStatuses }) => {
  const { tt } = useGlobalTranslation()
  const [passwordType, setPasswordType] = useState("password")
  const { formErrors } = useSelector(state => ({
    formErrors: state.forms.formErrors,
  }))

  const onLinkedinSubscriptionChange = linkedinSubscriptionId => {
    store.dispatch(actions.updateFormField("linkedin-subscription", linkedinSubscriptionId))
  }

  const getLabelModalAdditionalContent = () => {
    switch (statusName) {
      case "WRONG_AUTH":
        return (
          <div className="linkedin-connection-process-wrapper">
            <div className="linkedin-connection-process">
              <div className="linkedin-connection-process__image-wrapper">
                <SvgIcon className="linkedin-connection-process__image" icon="input-check-80" />
              </div>
              <div className="linkedin-connection-process__sub-text">
                <span className="small linkedin-connection-process__sub-text-status-text">
                  <LangText langKey="account.label.additional.context.wrong.auth.msg" />
                </span>
              </div>
            </div>
            <div className="linkedin-connection-process__inputs">
              <InputGroup
                field="emailAddressUpdate"
                label={tt("linkedin-email-address")}
                type="email"
                message={formErrors?.emailAddressUpdate}
              />
              <InputGroup
                field="passwordUpdate"
                label={tt("linkedin-password")}
                type={passwordType}
                passwordType={passwordType}
                setPasswordType={setPasswordType}
                message={formErrors?.passwordUpdate}
              />
            </div>
          </div>
        )
      case "PIN_REQUESTED":
      case "PIN_WRONG":
        return (
          <>
            <InputGroup
              field="pin"
              label={tt("linkedin-pin")}
              placeholder={tt("enter-linkedin-pin")}
              inputGroupClassName="input-on-surface"
            />
            <LangText langKey="account.label.additional.context.wrong.pin.msg" />{" "}
            <span
              onClick={async () => {
                const previousModalData = store.getState().app.infoModalData
                store.dispatch(
                  actions.showModal(
                    ModalVariant.SMALL,
                    tt("pin-required"),
                    <Loader fullWidth />,
                    FooterVariant.ACKNOWLEDGMENT,
                    { label: tt("cancel") },
                    undefined,
                    undefined,
                    undefined,
                    true,
                  ),
                )
                const success = await store.dispatch(actions.resendLinkedinPin(tt, person.id))
                if (success) {
                  accountUtils.showLabelModal(tt, person, accountStatuses)
                } else {
                  store.dispatch(actions.setModalData(previousModalData))
                }
              }}
              className="primary-color"
              style={{ cursor: "pointer" }}
            >
              <LangText langKey="here" />
            </span>
          </>
        )

      case "TWO_FACTOR_AUTH":
      case "TWO_FACTOR_AUTH_WRONG":
        return (
          <>
            <InputGroup
              field="twoFactorAuth"
              label={tt("linkedin-two-factor-auth-code")}
              placeholder={tt("enter-linkedin-two-factor-auth-code")}
              inputGroupClassName="input-on-surface"
            />
          </>
        )

      case "INVALID_SUBSCRIPTION":
        return (
          <div className="linkedin-connection-process-wrapper">
            <div className="linkedin-connection-process">
              <div className="linkedin-connection-process__image-wrapper">
                <SvgIcon className="linkedin-connection-process__image" icon="calendar-x-80" />
              </div>
              <div className="linkedin-connection-process__sub-text">
                <span className="small linkedin-connection-process__sub-text-status-text">
                  <LangText langKey="account.label.additional.context.invalid.subscription.msg" />
                </span>
              </div>
            </div>
            <LinkedinSubscription
              onChange={onLinkedinSubscriptionChange}
              wrapperClassName="invalid-subscription-wrapper"
              isConnectLinkedin
            />
          </div>
        )

      case "OFFLINE":
        return (
          <div className="linkedin-connection-process-wrapper">
            <div className="linkedin-connection-process">
              <div className="linkedin-connection-process__image-wrapper">
                <SvgIcon className="linkedin-connection-process__image" icon="clock-x-80" />
              </div>
              <div className="linkedin-connection-process__sub-text">
                <span className="small linkedin-connection-process__sub-text-status-text">
                  <LangText langKey="account.label.additional.context.offline.msg" />
                </span>
              </div>
            </div>
          </div>
        )

      case "CANCELED":
        return (
          <div className="linkedin-connection-process-wrapper">
            <div className="linkedin-connection-process">
              <div className="linkedin-connection-process__image-wrapper">
                <SvgIcon className="linkedin-connection-process__image" icon="circle-x-80" />
              </div>
              <div className="linkedin-connection-process__sub-text">
                <span className="small linkedin-connection-process__sub-text-status-text">
                  <LangText langKey="account.label.additional.context.cancel.msg" />
                </span>
              </div>
            </div>
          </div>
        )

      case "PAYMENT_REQUIRED":
        return (
          <div className="linkedin-connection-process-wrapper">
            <div className="linkedin-connection-process">
              <div className="linkedin-connection-process__image-wrapper">
                <SvgIcon className="linkedin-connection-process__image" icon="credit-card-pay-80" />
              </div>
              <div className="linkedin-connection-process__sub-text">
                <span className="small linkedin-connection-process__sub-text-status-text">
                  <LangText langKey="account.label.additional.context.payment.required.msg" />
                </span>
              </div>
            </div>
          </div>
        )

      case "RESTRICTED":
        return (
          <div className="linkedin-connection-process-wrapper">
            <div className="linkedin-connection-process">
              <div className="linkedin-connection-process__image-wrapper">
                <SvgIcon
                  className="linkedin-connection-process__image"
                  icon="circle-half-diagonal-80"
                />
              </div>
              <div className="linkedin-connection-process__sub-text">
                <span className="small linkedin-connection-process__sub-text-status-text">
                  <LangText langKey="account.label.additional.context.restricted.msg" />
                </span>
              </div>
            </div>
          </div>
        )

      case "UNKNOWN":
        return (
          <div className="linkedin-connection-process-wrapper">
            <div className="linkedin-connection-process">
              <div className="linkedin-connection-process__image-wrapper">
                <SvgIcon
                  className="linkedin-connection-process__image"
                  icon="circle-half-diagonal-80"
                />
              </div>
              <div className="linkedin-connection-process__sub-text">
                <span className="small linkedin-connection-process__sub-text-status-text">
                  <LangText langKey="account.label.additional.context.unknown.msg" />
                </span>
              </div>
            </div>
          </div>
        )

      default:
        return null
    }
  }

  return <>{getLabelModalAdditionalContent(person, statusName)}</>
}

// AccountLabelAdditionalContent.propTypes = {
//   person: PropTypes.instanceOf(Object).isRequired,
//   statusName: PropTypes.string.isRequired,
//   // userMessage: PropTypes.string.isRequired,
//   accountStatuses: PropTypes.arrayOf(
//     PropTypes.shape({
//       statusId: PropTypes.number,
//       statusName: PropTypes.string,
//       userMessage: PropTypes.string,
//     }),
//   ).isRequired,
// }

export default AccountLabelAdditionalContent
